import React from 'react'

import PrintQuestion from './PrintQuestion'
import {buildAnswerMap} from '../utils'

export default class PrintChangedQuestions extends React.Component {

  getQuestionsWithChangedAnswers(questions, answers, originalAnswers, questionsWithChanges) {
    return (
      <div className="scan-container">
        <h2>Aangepaste antwoorden</h2>
        {questionsWithChanges.length === 0 && 
          <div style={{fontSize: '15px', lineHeight: '1.3em'}}><p>U heeft nog geen antwoorden aangepast.</p></div>
        }
        <div className="scan-section">
          {questionsWithChanges.map((question, index) => (
            <div className="changed-group" key={index}>
              <PrintQuestion
                key={index}
                question={question}
                onChange={this.handleChange}
                state={answers}
                originalState={originalAnswers}
                completed={false}
                answermap={buildAnswerMap(questions, answers)}
              />
            </div>
            )
          )}
        </div>
      </div>
    )
  }

  render() {
    const { answers, originalAnswers, questions, questionsWithChanges } = this.props

    return (
      <div className="questions-changed">
        {this.getQuestionsWithChangedAnswers(questions, answers, originalAnswers, questionsWithChanges)}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PrintChangedQuestions.js